module.exports = __webpack_public_path__ + "static/media/img_ma.0d45a4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_ma.png
// module id = 380
// module chunks = 4